'use client';

import { HStack } from '@terra/ui-styled-system';
import {
  UnavailableIcon,
  CheckmarkCircle02Icon,
  Edit03Icon,
} from '@terra/ui-icons';
import { useTranslations } from 'next-intl';
import { MetaDefault } from '../../../components/typography';
import type { HITLStatus } from './hitl-types';

type HITLStatusIndicatorProps = {
  status: HITLStatus;
};

export function HITLStatusIndicator({ status }: HITLStatusIndicatorProps) {
  const t = useTranslations(
    'designSystem.chat.hitlRequestConfirmationPromptCard',
  );
  const tCommon = useTranslations('designSystem.common');

  if (status === 'pending') {
    return null;
  }

  const label =
    status === 'approve'
      ? t('approvedActionLabel')
      : status === 'edit'
        ? t('editedActionLabel')
        : tCommon('reject');
  const icon =
    status === 'approve' ? (
      <CheckmarkCircle02Icon size={12} />
    ) : status === 'edit' ? (
      <Edit03Icon size={12} />
    ) : (
      <UnavailableIcon size={12} />
    );

  return (
    <HStack gap={1} alignItems="center" color="fg.muted" flexShrink={0}>
      {icon}
      <MetaDefault as="span" color="fg.muted" whiteSpace="nowrap">
        {label}
      </MetaDefault>
    </HStack>
  );
}
